import { render, staticRenderFns } from "./modal-share-link.vue?vue&type=template&id=b38fd6f2&"
import script from "./modal-share-link.vue?vue&type=script&lang=js&"
export * from "./modal-share-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports